import { useMutation } from 'react-query';
import { useCurrentUser } from '@qualio/ui-components';
import { DigitalSignature } from '../types/digitalSignature';
import issueStepsApi from '../api/issueSteps.api';

export const useRevertIssueStep = (eventId: number, stepId: number) => {
  const { companyId } = useCurrentUser();

  return useMutation((payload: DigitalSignature) => issueStepsApi.revert(companyId, eventId, stepId, payload));
};
